import React from "react";
import { Link } from "react-router-dom";

/**
 * Shown when a detail endpoint returns 404.
 *
 * The wording here is a security surface, not just copy. The API deliberately returns
 * 404 rather than 403 for content outside your audience, so a visitor cannot tell
 * "this exists but is hidden from you" apart from "this does not exist". The message
 * must preserve that ambiguity — it never says "you don't have permission", which
 * would confirm the row exists.
 *
 * It also does not prompt for a login. Audience is a property of the CONTENT, not the
 * reader: this address may simply hold nothing. Suggesting "log in and you might get
 * in" would both leak that the row probably exists and misread the model.
 */
const NotAvailable = ({ kind = "page", backTo = "/", backLabel = "Back to home" }) => (
    <div className="not-available">
        <span className="empty-icon" aria-hidden="true">🔍</span>

        <h1>This {kind} isn't available</h1>

        <p>It may have been moved or removed, or the address may be wrong.</p>

        <Link to={backTo} className="btn btn-secondary">{backLabel}</Link>
    </div>
);

export default NotAvailable;
